/*
 * File: 富文本编辑器
 */
<template>
    <div ref="editorRef" style="height: 100%;"></div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';
import E from 'wangeditor';

// 编辑器的默认配置项
const editorConfig = {
    menus: [
        // 'head', // 标题
        // 'bold', // 粗体
        // 'fontSize', // 字号
        // 'fontName', // 字体
        // 'italic', // 斜体
        // 'underline', // 下划线
        // 'strikeThrough', // 删除线
        // 'foreColor', // 文字颜色
        // 'backColor', // 背景颜色
        // 'link', // 插入链接
        // 'list', // 列表
        // 'justify', // 对齐方式
        // 'quote', // 引用
        // 'emoticon', // 表情
        // 'image', // 插入图片
        // 'table', // 表格
        // 'video', // 插入视频
        // 'code', // 插入代码
        // 'undo', // 撤销
        // 'redo' // 重复
    ]
};

export default {
    name: 'Editor',
    props: {
        config: { // 传入编辑器的配置
            type: Object,
            default() {
                return {};
            }
        }
    },
    setup(props, setupContext) {
        const editor = ref(null);

        // 获取HTML内容
        const getContentHtml = () => editor.value.txt.html();
        // 获取纯文本内容
        const getContentText = () => editor.value.txt.text();
        // 设置编辑器内容
        const setContent = (val) => {
            editor.value.txt.html(val);
        };

        onMounted(() => {
            editor.value = new E(setupContext.refs.editorRef);
            // 配置编辑器
            editor.value.customConfig = { ...editorConfig, ...props.config };
            // 创建编辑器实例
            editor.value.create();
        });
        return {
            getContentHtml,
            getContentText,
            setContent
        };
    }
};
</script>
